/**
 * @generated SignedSource<<bdfcf23326639b725127c30f7e4e2bf7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectSprintsPage_Query$variables = {
  projectId?: string | null;
  groupId?: string | null;
  fetchLazyData: boolean;
  onlyActiveSprint: boolean;
  sprintIds?: ReadonlyArray<string | null> | null;
  personId: string;
};
export type ProjectSprintsPage_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly project: {
      readonly id: string;
    } | null;
    readonly projectGroup: {
      readonly projects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectSprintsPage_viewer">;
  } | null;
};
export type ProjectSprintsPage_Query = {
  variables: ProjectSprintsPage_Query$variables;
  response: ProjectSprintsPage_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchLazyData"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onlyActiveSprint"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sprintIds"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_sprints_optimized_v4"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"project_sprints_optimized_v4\")"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "groupId"
  }
],
v12 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "kind": "Variable",
  "name": "projectId",
  "variableName": "projectId"
},
v15 = {
  "kind": "Variable",
  "name": "sprintIds",
  "variableName": "sprintIds"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "demo",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "stage",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v9/*: any*/),
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profile",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskLevels",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintLengthInDays",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingAutoCalculated",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useManualAllocations",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetWork",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "disabledRoles",
      "plural": true,
      "selections": (v10/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v51 = [
  (v9/*: any*/),
  (v17/*: any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v51/*: any*/),
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v54 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectPersonTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectPerson",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initials",
                "storageKey": null
              },
              (v49/*: any*/),
              (v50/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/)
            ],
            "storageKey": null
          },
          (v52/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraStatusId",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v58 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PhaseTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v51/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v67 = {
  "condition": "fetchLazyData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v66/*: any*/)
  ]
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "savedPerformance",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnfinishedTask",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "SprintPersonTypeConnection",
  "kind": "LinkedField",
  "name": "sprintPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SprintPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SprintPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            {
              "condition": "fetchLazyData",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availableMinutes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "scheduledMinutes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "taskAvailableMinutes",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v47/*: any*/),
                (v48/*: any*/),
                (v49/*: any*/),
                (v50/*: any*/),
                (v52/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "sprintPersons(first:1000000)"
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "SprintIntegrationsType",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adoId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v74 = [
  {
    "kind": "Variable",
    "name": "activeSprint",
    "variableName": "onlyActiveSprint"
  },
  {
    "kind": "Literal",
    "name": "approvedOnly",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "context",
    "value": "SPRINT"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  },
  {
    "kind": "Literal",
    "name": "simpleResponse",
    "value": true
  },
  (v15/*: any*/)
],
v75 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskReadOnly",
  "kind": "LinkedField",
  "name": "readOnly",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isReadOnly",
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanDeleteTask",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCantDeleteTaskReason",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNovaConversation",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "novaRunningRunId",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecast",
  "storageKey": null
},
v83 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v85 = {
  "condition": "fetchLazyData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v59/*: any*/),
    {
      "alias": null,
      "args": (v83/*: any*/),
      "concreteType": "TimeRegTypeConnection",
      "kind": "LinkedField",
      "name": "timeRegistrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRegTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRegType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutesRegistered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "billableMinutesRegistered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Role",
                      "kind": "LinkedField",
                      "name": "role",
                      "plural": false,
                      "selections": (v10/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v25/*: any*/)
              ],
              "storageKey": null
            },
            (v72/*: any*/)
          ],
          "storageKey": null
        },
        (v73/*: any*/)
      ],
      "storageKey": "timeRegistrations(first:10000)"
    },
    {
      "alias": null,
      "args": (v83/*: any*/),
      "filters": ([]/*: any*/),
      "handle": "connection",
      "key": "Task_timeRegistrations",
      "kind": "LinkedHandle",
      "name": "timeRegistrations"
    },
    (v84/*: any*/)
  ]
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDependency",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canStart",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBeSetToDone",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subTaskCount",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLockedTime",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvoicedTime",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChildren",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskLabel",
  "kind": "LinkedField",
  "name": "taskLabels",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "label",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v17/*: any*/),
        (v107/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v17/*: any*/),
    (v90/*: any*/),
    (v91/*: any*/),
    (v92/*: any*/)
  ],
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskDismissedNotifications",
  "kind": "LinkedField",
  "name": "taskDismissedNotifications",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskOverrunPredictionDismissed",
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v51/*: any*/),
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskHierarchy",
  "storageKey": null
},
v115 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v116 = [
  (v115/*: any*/)
],
v117 = {
  "alias": null,
  "args": (v116/*: any*/),
  "concreteType": "DependencyTypeConnection",
  "kind": "LinkedField",
  "name": "thisTaskDependsOn",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DependencyTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DependencyType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "thisDependsOnTask",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v17/*: any*/),
                (v90/*: any*/),
                (v91/*: any*/),
                (v92/*: any*/),
                (v62/*: any*/),
                (v61/*: any*/),
                (v60/*: any*/)
              ],
              "storageKey": null
            },
            (v25/*: any*/)
          ],
          "storageKey": null
        },
        (v72/*: any*/)
      ],
      "storageKey": null
    },
    (v73/*: any*/)
  ],
  "storageKey": "thisTaskDependsOn(first:1000)"
},
v118 = {
  "alias": null,
  "args": (v116/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "Task_thisTaskDependsOn",
  "kind": "LinkedHandle",
  "name": "thisTaskDependsOn"
},
v119 = [
  (v9/*: any*/),
  (v46/*: any*/)
],
v120 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v119/*: any*/),
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "followers",
  "plural": true,
  "selections": (v119/*: any*/),
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "parentTask",
  "plural": false,
  "selections": (v51/*: any*/),
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskProgress",
  "kind": "LinkedField",
  "name": "progressDetails",
  "plural": false,
  "selections": [
    (v84/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": (v74/*: any*/),
  "filters": ([]/*: any*/),
  "handle": "connection",
  "key": "Project_tasks",
  "kind": "LinkedHandle",
  "name": "tasks"
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupStatusColumnId",
  "storageKey": null
},
v126 = [
  (v115/*: any*/),
  {
    "kind": "Literal",
    "name": "onlyProjectGroupSprints",
    "value": true
  }
],
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupSprintId",
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProjectGroupSprint",
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectGroupId",
  "storageKey": null
},
v130 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v131 = [
  (v12/*: any*/),
  {
    "kind": "Literal",
    "name": "lazyLoadData",
    "value": true
  }
],
v132 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backendId",
  "storageKey": null
},
v133 = [
  (v12/*: any*/),
  {
    "kind": "Variable",
    "name": "projectGroupId",
    "variableName": "groupId"
  },
  (v14/*: any*/)
],
v134 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JiraSyncSettingsType",
    "kind": "LinkedField",
    "name": "syncSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isJiraToForecastOneWaySync",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectSprintsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(first:1000000)"
              }
            ],
            "storageKey": null
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "fetchLazyData",
                "variableName": "fetchLazyData"
              },
              {
                "kind": "Variable",
                "name": "groupId",
                "variableName": "groupId"
              },
              {
                "kind": "Variable",
                "name": "onlyActiveSprint",
                "variableName": "onlyActiveSprint"
              },
              {
                "kind": "Variable",
                "name": "personId",
                "variableName": "personId"
              },
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectSprintsPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectSprintsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineRouteAccess",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinancialSourceSettings",
                "kind": "LinkedField",
                "name": "financialSourceSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenue",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v24/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskFollowers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskOwner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isJiraProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestProjectId",
                "storageKey": null
              },
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v44/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": (v54/*: any*/),
                "storageKey": "projectPersons(first:1000000)"
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "StatusColumnV2TypeConnection",
                "kind": "LinkedField",
                "name": "statusColumnsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2TypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusColumnV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v55/*: any*/),
                          (v17/*: any*/),
                          (v56/*: any*/),
                          (v57/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "statusColumnsV2(first:1000000)"
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "PhaseTypeConnection",
                "kind": "LinkedField",
                "name": "phases",
                "plural": false,
                "selections": (v58/*: any*/),
                "storageKey": "phases(first:1000000)"
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "SprintTypeConnection",
                "kind": "LinkedField",
                "name": "sprints",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SprintTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Sprint",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v17/*: any*/),
                          (v59/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forecast",
                            "storageKey": null
                          },
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v62/*: any*/),
                          (v63/*: any*/),
                          (v64/*: any*/),
                          (v65/*: any*/),
                          (v67/*: any*/),
                          (v68/*: any*/),
                          (v69/*: any*/),
                          (v70/*: any*/),
                          (v71/*: any*/),
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v72/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v73/*: any*/)
                ],
                "storageKey": "sprints(first:1000000)"
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_sprints",
                "kind": "LinkedHandle",
                "name": "sprints"
              },
              {
                "alias": null,
                "args": (v74/*: any*/),
                "concreteType": "TaskTypeConnection",
                "kind": "LinkedField",
                "name": "tasks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v75/*: any*/),
                          (v76/*: any*/),
                          (v77/*: any*/),
                          (v17/*: any*/),
                          (v66/*: any*/),
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v80/*: any*/),
                          (v81/*: any*/),
                          (v82/*: any*/),
                          (v85/*: any*/),
                          (v86/*: any*/),
                          (v87/*: any*/),
                          (v88/*: any*/),
                          (v89/*: any*/),
                          (v90/*: any*/),
                          (v91/*: any*/),
                          (v92/*: any*/),
                          (v62/*: any*/),
                          (v61/*: any*/),
                          (v60/*: any*/),
                          (v93/*: any*/),
                          (v94/*: any*/),
                          (v95/*: any*/),
                          (v96/*: any*/),
                          (v97/*: any*/),
                          (v98/*: any*/),
                          (v99/*: any*/),
                          (v100/*: any*/),
                          (v101/*: any*/),
                          (v102/*: any*/),
                          (v103/*: any*/),
                          (v104/*: any*/),
                          (v105/*: any*/),
                          (v106/*: any*/),
                          (v108/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v65/*: any*/),
                              (v64/*: any*/),
                              (v63/*: any*/),
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2",
                            "kind": "LinkedField",
                            "name": "statusColumnV2",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v17/*: any*/),
                              (v57/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v109/*: any*/),
                          (v52/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "assignedPersons",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v45/*: any*/),
                              (v47/*: any*/),
                              (v48/*: any*/),
                              (v110/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v46/*: any*/),
                              (v53/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v111/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v17/*: any*/),
                              (v24/*: any*/),
                              (v112/*: any*/),
                              (v113/*: any*/),
                              (v30/*: any*/),
                              (v16/*: any*/),
                              (v18/*: any*/),
                              (v29/*: any*/),
                              (v31/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v19/*: any*/),
                              (v26/*: any*/),
                              (v114/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v117/*: any*/),
                          (v118/*: any*/),
                          (v120/*: any*/),
                          (v121/*: any*/),
                          (v122/*: any*/),
                          (v123/*: any*/),
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v72/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v73/*: any*/)
                ],
                "storageKey": null
              },
              (v124/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v17/*: any*/),
                          (v24/*: any*/),
                          (v26/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v27/*: any*/),
                          (v22/*: any*/),
                          (v28/*: any*/),
                          (v32/*: any*/),
                          (v30/*: any*/),
                          (v29/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v31/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v21/*: any*/),
                          (v44/*: any*/),
                          (v112/*: any*/),
                          {
                            "alias": null,
                            "args": (v83/*: any*/),
                            "concreteType": "ProjectPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "projectPersons",
                            "plural": false,
                            "selections": (v54/*: any*/),
                            "storageKey": "projectPersons(first:10000)"
                          },
                          {
                            "alias": null,
                            "args": (v13/*: any*/),
                            "concreteType": "StatusColumnV2TypeConnection",
                            "kind": "LinkedField",
                            "name": "statusColumnsV2",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StatusColumnV2TypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StatusColumnV2",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v55/*: any*/),
                                      (v17/*: any*/),
                                      (v125/*: any*/),
                                      (v56/*: any*/),
                                      (v57/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "statusColumnsV2(first:1000000)"
                          },
                          {
                            "alias": null,
                            "args": (v116/*: any*/),
                            "concreteType": "PhaseTypeConnection",
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": false,
                            "selections": (v58/*: any*/),
                            "storageKey": "phases(first:1000)"
                          },
                          {
                            "alias": null,
                            "args": (v126/*: any*/),
                            "concreteType": "SprintTypeConnection",
                            "kind": "LinkedField",
                            "name": "sprints",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SprintTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v17/*: any*/),
                                      (v127/*: any*/),
                                      (v128/*: any*/),
                                      (v60/*: any*/),
                                      (v61/*: any*/),
                                      (v62/*: any*/),
                                      (v63/*: any*/),
                                      (v64/*: any*/),
                                      (v65/*: any*/),
                                      (v67/*: any*/),
                                      (v68/*: any*/),
                                      (v69/*: any*/),
                                      (v71/*: any*/),
                                      (v25/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v72/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v73/*: any*/)
                            ],
                            "storageKey": "sprints(first:1000,onlyProjectGroupSprints:true)"
                          },
                          {
                            "alias": null,
                            "args": (v126/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "Project_sprints",
                            "kind": "LinkedHandle",
                            "name": "sprints"
                          },
                          {
                            "alias": null,
                            "args": (v74/*: any*/),
                            "concreteType": "TaskTypeConnection",
                            "kind": "LinkedField",
                            "name": "tasks",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Task",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v75/*: any*/),
                                      (v76/*: any*/),
                                      (v77/*: any*/),
                                      (v104/*: any*/),
                                      (v106/*: any*/),
                                      (v17/*: any*/),
                                      (v66/*: any*/),
                                      (v78/*: any*/),
                                      (v79/*: any*/),
                                      (v80/*: any*/),
                                      (v81/*: any*/),
                                      (v82/*: any*/),
                                      (v85/*: any*/),
                                      (v86/*: any*/),
                                      (v87/*: any*/),
                                      (v88/*: any*/),
                                      (v89/*: any*/),
                                      (v90/*: any*/),
                                      (v91/*: any*/),
                                      (v92/*: any*/),
                                      (v62/*: any*/),
                                      (v61/*: any*/),
                                      (v60/*: any*/),
                                      (v93/*: any*/),
                                      (v94/*: any*/),
                                      (v95/*: any*/),
                                      (v96/*: any*/),
                                      (v97/*: any*/),
                                      (v98/*: any*/),
                                      (v99/*: any*/),
                                      (v100/*: any*/),
                                      (v101/*: any*/),
                                      (v102/*: any*/),
                                      (v103/*: any*/),
                                      (v105/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectType",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v24/*: any*/),
                                          (v29/*: any*/),
                                          (v31/*: any*/),
                                          (v16/*: any*/),
                                          (v18/*: any*/),
                                          (v17/*: any*/),
                                          (v19/*: any*/),
                                          (v36/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          (v30/*: any*/),
                                          (v26/*: any*/),
                                          (v23/*: any*/),
                                          (v113/*: any*/),
                                          (v53/*: any*/),
                                          (v44/*: any*/),
                                          (v114/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v108/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Sprint",
                                        "kind": "LinkedField",
                                        "name": "sprint",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v65/*: any*/),
                                          (v64/*: any*/),
                                          (v63/*: any*/),
                                          (v68/*: any*/),
                                          (v17/*: any*/),
                                          (v127/*: any*/),
                                          (v128/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StatusColumnV2",
                                        "kind": "LinkedField",
                                        "name": "statusColumnV2",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v17/*: any*/),
                                          (v57/*: any*/),
                                          (v125/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v109/*: any*/),
                                      (v52/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "assignedPersons",
                                        "plural": true,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v45/*: any*/),
                                          (v47/*: any*/),
                                          (v48/*: any*/),
                                          (v49/*: any*/),
                                          (v50/*: any*/),
                                          (v46/*: any*/),
                                          (v53/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v111/*: any*/),
                                      (v117/*: any*/),
                                      (v118/*: any*/),
                                      (v120/*: any*/),
                                      (v121/*: any*/),
                                      (v122/*: any*/),
                                      (v123/*: any*/),
                                      (v25/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v72/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v73/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v124/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(first:1000000)"
              },
              (v9/*: any*/),
              (v129/*: any*/),
              (v17/*: any*/),
              (v107/*: any*/),
              {
                "alias": "projectHeaderProjects",
                "args": (v130/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v22/*: any*/),
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v72/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v73/*: any*/)
                ],
                "storageKey": "projects(first:1)"
              },
              {
                "alias": "projectHeaderProjects",
                "args": (v130/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "ProjectGroup_projectHeaderProjects",
                "kind": "LinkedHandle",
                "name": "projects"
              },
              {
                "alias": null,
                "args": (v131/*: any*/),
                "concreteType": "ProjectGroupSprintTypeConnection",
                "kind": "LinkedField",
                "name": "projectGroupSprints",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectGroupSprintTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectGroupSprintType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v17/*: any*/),
                          (v70/*: any*/),
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v72/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v73/*: any*/)
                ],
                "storageKey": "projectGroupSprints(first:1000000,lazyLoadData:true)"
              },
              {
                "alias": null,
                "args": (v131/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "ProjectGroup_projectGroupSprints",
                "kind": "LinkedHandle",
                "name": "projectGroupSprints"
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          (v110/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          (v132/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timerStartDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "excludeFromCompanyLockedPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "timerTask",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v16/*: any*/),
                      (v18/*: any*/),
                      (v17/*: any*/),
                      (v26/*: any*/),
                      (v20/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(first:1000000)"
          },
          {
            "alias": null,
            "args": (v133/*: any*/),
            "concreteType": "FilterTypeConnection",
            "kind": "LinkedField",
            "name": "filters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Filter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "section",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      },
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v72/*: any*/)
                ],
                "storageKey": null
              },
              (v73/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v133/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_filters",
            "kind": "LinkedHandle",
            "name": "filters"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraCloudEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraServerEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyIntegrationsType",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraCloud",
                    "plural": false,
                    "selections": (v134/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyJiraSettingsType",
                    "kind": "LinkedField",
                    "name": "jiraServer",
                    "plural": false,
                    "selections": (v134/*: any*/),
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v132/*: any*/),
              (v17/*: any*/),
              (v43/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsingProjectAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsingMixedAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "personId"
                  }
                ],
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v52/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v51/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roles(first:1000000)"
              },
              {
                "alias": null,
                "args": [
                  (v12/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "labelType",
                    "value": "TASK"
                  }
                ],
                "concreteType": "LabelTypeConnection",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v17/*: any*/),
                          (v107/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LabelCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": (v51/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "labels(first:1000000,labelType:\"TASK\")"
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "ClientTypeConnection",
                "kind": "LinkedField",
                "name": "clients",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "logoId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "logoDefaultId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "clients(first:1000000)"
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "TeamTypeConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": (v13/*: any*/),
                            "concreteType": "TeamPersonTypeConnection",
                            "kind": "LinkedField",
                            "name": "teamPersons",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamPersonTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamPerson",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "person",
                                        "plural": false,
                                        "selections": (v10/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "teamPersons(first:1000000)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "teams(first:1000000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "friday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sunday",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "ProjectGroupTypeConnection",
            "kind": "LinkedField",
            "name": "projectGroups",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectGroupTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectGroupType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v129/*: any*/),
                      (v17/*: any*/),
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v72/*: any*/)
                ],
                "storageKey": null
              },
              (v73/*: any*/)
            ],
            "storageKey": "projectGroups(first:1000000)"
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "Viewer_projectGroups",
            "kind": "LinkedHandle",
            "name": "projectGroups"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "companyProjectId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectServiceProjectType",
            "kind": "LinkedField",
            "name": "psProject",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "psProgram",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v17/*: any*/),
                  (v107/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prefix",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isViewerProgramMember",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ebec6974f6b7ed60c3c4e9154ba39fa1",
    "id": null,
    "metadata": {},
    "name": "ProjectSprintsPage_Query",
    "operationKind": "query",
    "text": "query ProjectSprintsPage_Query(\n  $projectId: String\n  $groupId: String\n  $fetchLazyData: Boolean!\n  $onlyActiveSprint: Boolean!\n  $sprintIds: [String]\n  $personId: ID!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"project_sprints_optimized_v4\")\n    project(id: $projectId) {\n      id\n    }\n    projectGroup(id: $groupId) {\n      projects(first: 1000000) {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n      id\n    }\n    ...ProjectSprintsPage_viewer_1bGJwq\n    id\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment LabelDropdownJS_labels on Label {\n  color\n  name\n  id\n  category {\n    id\n    name\n  }\n}\n\nfragment ProjectHeader_project on ProjectType {\n  id\n  companyProjectId\n  ...ProjectIndicatorJS_project\n  name\n  projectColor\n  isInProjectGroup\n  projectGroupCompanyId\n  projectGroupName\n  projectGroupColor\n  useBaseline\n  budgetType\n  sprintTimeBox\n}\n\nfragment ProjectHeader_projectGroup on ProjectGroupType {\n  companyProjectGroupId\n  name\n  color\n  projectHeaderProjects: projects(first: 1) {\n    edges {\n      node {\n        id\n        sprintTimeBox\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProjectHeader_psProject on ProjectServiceProjectType {\n  name\n  psProgram {\n    id\n    name\n    color\n    prefix\n    isViewerProgramMember\n  }\n}\n\nfragment ProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment ProjectSprintsPage_viewer_1bGJwq on Viewer {\n  id\n  language\n  email\n  firstName\n  lastName\n  backendId\n  harvestUser\n  timerStartDate\n  actualPersonId\n  excludeFromCompanyLockedPeriod\n  submitLockedDateYear\n  submitLockedDateMonth\n  submitLockedDateDay\n  availableFeatureFlags {\n    key\n    id\n  }\n  timerTask {\n    id\n  }\n  projects(first: 1000000) {\n    edges {\n      node {\n        id\n        companyProjectId\n        customProjectId\n        name\n        stage {\n          __typename\n          id\n          name\n          profile\n        }\n        isInProjectGroup\n        projectColor\n      }\n    }\n  }\n  filters(first: 1000000, projectId: $projectId, projectGroupId: $groupId) {\n    edges {\n      node {\n        id\n        name\n        section\n        value\n        updatedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  company {\n    ...genericTaskContextMenu_company\n    id\n    backendId\n    name\n    currency\n    harvestEnabled\n    lockedPeriodYear\n    lockedPeriodMonth\n    lockedPeriodDay\n    isUsingProjectAllocation\n    isUsingMixedAllocation\n    person(id: $personId) {\n      id\n      role {\n        id\n        name\n      }\n    }\n    modules {\n      moduleType\n      id\n    }\n    roles(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    labels(first: 1000000, labelType: TASK) {\n      edges {\n        node {\n          id\n          name\n          color\n          category {\n            id\n            name\n          }\n          ...LabelDropdownJS_labels\n        }\n      }\n    }\n    clients(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          logoId\n          logoDefaultId\n        }\n      }\n    }\n    teams(first: 1000000) {\n      edges {\n        ...TeamDropdown_teams\n        node {\n          id\n          name\n          teamPersons(first: 1000000) {\n            edges {\n              node {\n                id\n                person {\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    monday\n    tuesday\n    wednesday\n    thursday\n    friday\n    saturday\n    sunday\n  }\n  projectGroup(id: $groupId) {\n    ...ProjectHeader_projectGroup\n    ...SecondaryNavigation_projectGroup\n    id\n    companyProjectGroupId\n    name\n    color\n    projectGroupSprints(first: 1000000, lazyLoadData: true) {\n      edges {\n        node {\n          id\n          name\n          sprintPersons(first: 1000000) {\n            edges {\n              node {\n                id\n                availableMinutes @include(if: $fetchLazyData)\n                scheduledMinutes @include(if: $fetchLazyData)\n                taskAvailableMinutes @include(if: $fetchLazyData)\n                person {\n                  id\n                  firstName\n                  lastName\n                  profilePictureId\n                  profilePictureDefaultId\n                  role {\n                    id\n                    name\n                  }\n                }\n              }\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    projects(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          demo\n          stage {\n            __typename\n            id\n            name\n            profile\n          }\n          companyProjectId\n          customProjectId\n          ...DeprecatedProjectIndicatorJS_project\n          taskLevels\n          sprintTimeBox\n          sprintLengthInDays\n          useManualAllocations\n          remainingAutoCalculated\n          projectColor\n          estimationUnit\n          projectStartYear\n          projectStartMonth\n          projectStartDay\n          projectEndYear\n          projectEndMonth\n          projectEndDay\n          minutesPerEstimationPoint\n          manualProgressOnProjectEnabled\n          manualProgressOnPhasesEnabled\n          manualProgressOnTasksEnabled\n          budgetWork\n          budgetType\n          rateCard {\n            id\n            currency\n            disabledRoles {\n              id\n            }\n          }\n          client {\n            id\n            name\n          }\n          projectPersons(first: 10000) {\n            edges {\n              node {\n                person {\n                  id\n                  active\n                  permissions\n                  firstName\n                  lastName\n                  fullName\n                  initials\n                  profilePictureId\n                  profilePictureDefaultId\n                  role {\n                    id\n                    name\n                  }\n                  client {\n                    id\n                  }\n                }\n                role {\n                  id\n                  name\n                }\n                id\n              }\n            }\n          }\n          statusColumnsV2(first: 1000000) {\n            edges {\n              node {\n                id\n                order\n                name\n                projectGroupStatusColumnId\n                jiraStatusId\n                category\n              }\n            }\n          }\n          phases(first: 1000) {\n            edges {\n              node {\n                id\n                name\n              }\n            }\n          }\n          sprints(first: 1000, onlyProjectGroupSprints: true) {\n            edges {\n              node {\n                id\n                name\n                projectGroupSprintId\n                isProjectGroupSprint\n                startDay\n                startMonth\n                startYear\n                endDay\n                endMonth\n                endYear\n                description @include(if: $fetchLazyData)\n                savedPerformance\n                hasUnfinishedTask\n                integrations {\n                  id\n                  jiraId\n                  adoId\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          tasks(first: 100000, approvedOnly: true, simpleResponse: true, activeSprint: $onlyActiveSprint, sprintIds: $sprintIds, context: \"SPRINT\") {\n            edges {\n              node {\n                id\n                readOnly {\n                  isReadOnly\n                  id\n                }\n                userCanDeleteTask\n                userCantDeleteTaskReason\n                hasChildren\n                sageIntacctId\n                name\n                description\n                highPriority\n                companyTaskId\n                hasNovaConversation\n                novaRunningRunId\n                estimateForecast\n                timeLeft @include(if: $fetchLazyData)\n                timeRegistrations(first: 10000) @include(if: $fetchLazyData) {\n                  edges {\n                    node {\n                      id\n                      minutesRegistered\n                      billableMinutesRegistered\n                      invoiced\n                      person {\n                        id\n                        role {\n                          id\n                        }\n                      }\n                      __typename\n                    }\n                    cursor\n                  }\n                  pageInfo {\n                    endCursor\n                    hasNextPage\n                  }\n                }\n                progress @include(if: $fetchLazyData)\n                approved\n                sortOrder\n                blocked\n                bug\n                deadlineYear\n                deadlineMonth\n                deadlineDay\n                startYear\n                startMonth\n                startDay\n                startFrom\n                deadlineFrom\n                hasDependency\n                canStart\n                canBeSetToDone\n                subTaskCount\n                latestUiUpdateAt\n                hasLockedTime\n                hasInvoicedTime\n                favoured\n                billable\n                parentTaskId\n                project {\n                  id\n                  demo\n                  estimationUnit\n                  minutesPerEstimationPoint\n                  companyProjectId\n                  customProjectId\n                  ...DeprecatedProjectIndicatorJS_project\n                  projectEndYear\n                  projectEndMonth\n                  projectEndDay\n                  projectColor\n                  remainingAutoCalculated\n                  name\n                  stage {\n                    __typename\n                    id\n                    name\n                    profile\n                  }\n                  projectGroupId\n                  harvestProject {\n                    id\n                  }\n                  client {\n                    id\n                  }\n                  rateCard {\n                    id\n                    currency\n                    disabledRoles {\n                      id\n                    }\n                  }\n                  useTaskHierarchy\n                }\n                taskLabels {\n                  id\n                  label {\n                    id\n                    name\n                    color\n                  }\n                }\n                sprint {\n                  id\n                  endYear\n                  endMonth\n                  endDay\n                  savedPerformance\n                  name\n                  projectGroupSprintId\n                  isProjectGroupSprint\n                }\n                statusColumnV2 {\n                  id\n                  name\n                  category\n                  projectGroupStatusColumnId\n                }\n                phase {\n                  id\n                  name\n                  deadlineYear\n                  deadlineMonth\n                  deadlineDay\n                }\n                role {\n                  id\n                  name\n                }\n                assignedPersons {\n                  id\n                  active\n                  firstName\n                  lastName\n                  profilePictureId\n                  profilePictureDefaultId\n                  permissions\n                  client {\n                    id\n                  }\n                }\n                taskDismissedNotifications {\n                  taskOverrunPredictionDismissed\n                  id\n                }\n                thisTaskDependsOn(first: 1000) {\n                  edges {\n                    node {\n                      id\n                      type\n                      thisDependsOnTask {\n                        id\n                        name\n                        deadlineYear\n                        deadlineMonth\n                        deadlineDay\n                        startYear\n                        startMonth\n                        startDay\n                      }\n                      __typename\n                    }\n                    cursor\n                  }\n                  pageInfo {\n                    endCursor\n                    hasNextPage\n                  }\n                }\n                owner {\n                  id\n                  permissions\n                }\n                followers {\n                  id\n                  permissions\n                }\n                parentTask {\n                  id\n                  name\n                }\n                progressDetails {\n                  progress\n                  id\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n        }\n      }\n    }\n  }\n  projectGroups(first: 1000000) {\n    edges {\n      node {\n        id\n        companyProjectGroupId\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  project(id: $projectId) {\n    ...ProjectHeader_project\n    ...SecondaryNavigation_project\n    id\n    demo\n    name\n    isInProjectGroup\n    projectGroupId\n    stage {\n      __typename\n      id\n      name\n      profile\n    }\n    companyProjectId\n    customProjectId\n    taskLevels\n    sprintTimeBox\n    sprintLengthInDays\n    projectColor\n    estimationUnit\n    remainingAutoCalculated\n    minutesPerEstimationPoint\n    useManualAllocations\n    useTaskFollowers\n    useTaskOwner\n    isJiraProject\n    harvestProjectId\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    manualProgressOnProjectEnabled\n    manualProgressOnPhasesEnabled\n    manualProgressOnTasksEnabled\n    budgetWork\n    budgetType\n    rateCard {\n      id\n      currency\n      disabledRoles {\n        id\n      }\n    }\n    projectPersons(first: 1000000) {\n      edges {\n        node {\n          person {\n            id\n            active\n            permissions\n            firstName\n            lastName\n            fullName\n            initials\n            profilePictureId\n            profilePictureDefaultId\n            role {\n              id\n              name\n            }\n            client {\n              id\n            }\n          }\n          role {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n    statusColumnsV2(first: 1000000) {\n      edges {\n        node {\n          id\n          order\n          name\n          jiraStatusId\n          category\n        }\n      }\n    }\n    phases(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    sprints(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          timeLeft\n          forecast\n          startDay\n          startMonth\n          startYear\n          endDay\n          endMonth\n          endYear\n          description @include(if: $fetchLazyData)\n          savedPerformance\n          hasUnfinishedTask\n          sprintPersons(first: 1000000) {\n            edges {\n              node {\n                id\n                availableMinutes @include(if: $fetchLazyData)\n                scheduledMinutes @include(if: $fetchLazyData)\n                taskAvailableMinutes @include(if: $fetchLazyData)\n                person {\n                  id\n                  firstName\n                  lastName\n                  profilePictureId\n                  profilePictureDefaultId\n                  role {\n                    id\n                    name\n                  }\n                }\n              }\n            }\n          }\n          integrations {\n            id\n            jiraId\n            adoId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    tasks(first: 100000, approvedOnly: true, simpleResponse: true, activeSprint: $onlyActiveSprint, sprintIds: $sprintIds, context: \"SPRINT\") {\n      edges {\n        node {\n          id\n          readOnly {\n            isReadOnly\n            id\n          }\n          userCanDeleteTask\n          userCantDeleteTaskReason\n          name\n          description\n          highPriority\n          companyTaskId\n          hasNovaConversation\n          novaRunningRunId\n          estimateForecast\n          timeLeft @include(if: $fetchLazyData)\n          timeRegistrations(first: 10000) @include(if: $fetchLazyData) {\n            edges {\n              node {\n                id\n                minutesRegistered\n                billableMinutesRegistered\n                invoiced\n                person {\n                  id\n                  role {\n                    id\n                  }\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          progress @include(if: $fetchLazyData)\n          approved\n          sortOrder\n          blocked\n          bug\n          deadlineYear\n          deadlineMonth\n          deadlineDay\n          startYear\n          startMonth\n          startDay\n          startFrom\n          deadlineFrom\n          hasDependency\n          canStart\n          canBeSetToDone\n          subTaskCount\n          latestUiUpdateAt\n          hasLockedTime\n          hasInvoicedTime\n          favoured\n          billable\n          hasChildren\n          parentTaskId\n          sageIntacctId\n          taskLabels {\n            id\n            label {\n              id\n              name\n              color\n            }\n          }\n          sprint {\n            id\n            endYear\n            endMonth\n            endDay\n            name\n          }\n          statusColumnV2 {\n            id\n            name\n            category\n          }\n          phase {\n            id\n            name\n            deadlineYear\n            deadlineMonth\n            deadlineDay\n          }\n          role {\n            id\n            name\n          }\n          assignedPersons {\n            id\n            active\n            firstName\n            lastName\n            email\n            profilePictureId\n            profilePictureDefaultId\n            permissions\n            client {\n              id\n            }\n          }\n          taskDismissedNotifications {\n            taskOverrunPredictionDismissed\n            id\n          }\n          project {\n            id\n            name\n            demo\n            client {\n              id\n              name\n            }\n            harvestProject {\n              id\n            }\n            remainingAutoCalculated\n            companyProjectId\n            customProjectId\n            estimationUnit\n            minutesPerEstimationPoint\n            projectStartYear\n            projectStartMonth\n            projectStartDay\n            projectEndYear\n            projectEndMonth\n            projectEndDay\n            projectColor\n            stage {\n              __typename\n              id\n              name\n              profile\n            }\n            useTaskHierarchy\n          }\n          thisTaskDependsOn(first: 1000) {\n            edges {\n              node {\n                id\n                type\n                thisDependsOnTask {\n                  id\n                  name\n                  deadlineYear\n                  deadlineMonth\n                  deadlineDay\n                  startYear\n                  startMonth\n                  startDay\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          owner {\n            id\n            permissions\n          }\n          followers {\n            id\n            permissions\n          }\n          parentTask {\n            id\n            name\n          }\n          progressDetails {\n            progress\n            id\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  psProject(companyProjectId: $projectId) {\n    ...ProjectHeader_psProject\n    id\n  }\n}\n\nfragment SecondaryNavigation_project on ProjectType {\n  companyProjectId\n  customProjectId\n  sprintTimeBox\n  budgetType\n  projectGroupId\n  useBaseline\n  baselineRouteAccess\n  hasInvoices\n  financialSourceSettings {\n    plannedCost\n    plannedRevenue\n    actualCost\n    actualRevenue\n    forecastCost\n    forecastRevenue\n    id\n  }\n}\n\nfragment SecondaryNavigation_projectGroup on ProjectGroupType {\n  companyProjectGroupId\n  projectHeaderProjects: projects(first: 1) {\n    edges {\n      node {\n        id\n        sprintTimeBox\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamDropdown_teams on TeamTypeEdge {\n  node {\n    name\n    id\n  }\n}\n\nfragment genericTaskContextMenu_company on Company {\n  id\n  jiraCloudEnabled\n  jiraServerEnabled\n  integrations {\n    jiraCloud {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    jiraServer {\n      syncSettings {\n        isJiraToForecastOneWaySync\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5720be1867160aa2db1c7631fe08a672";

export default node;
